import { CustomField } from "./customFields"
import { Asset } from "./assets"
import { PaginatedRecords } from "./common"
export interface Cluster {
  createdDate: Date,
  filters: Filter[] | null,
  id: string,
  modifiedDate: Date,
  name: string,
}
export interface Filter {
  operator: Operators | null,
  property: Property,
  value: any
  expiryDateFilter?: AssetExpiry | null,
  id?: string
}

export enum Operators {
  is = "is",
  is_not = "is_not",
  is_empty = "is_empty",
  is_not_empty = "is_not_empty",
  contains = "contains",
  expired = "expired",
  not_expired = "not_expired",
  expiring = "expiring",
}

export enum PropertyEnum {
  asset = "asset",
  title = "title",
  stream = "stream",
  file_type = "file_type",
  tags = "tags",
  group = "group",
  expiry_date = "expiryDate",
  custom_field = "custom_field"
}

export enum AssetsActionEnum {
  delete_assets = "delete_assets",
  update_assets = "update_assets"
}

export enum FilterActionEnum {
  add_new_filter= "add_new_filter",
  primary_filter = "primary_filter",
  sub_filter = "sub_filter",
  input_value = "input_value",
  expiry_date = "expiry_date",
  delete_filter = "delete_filter",
  none = "none"
}



export interface Property {
  type: PropertyEnum,
  fieldId?: string,
  item?: CustomField
}

export enum AssetExpiry {
  one_month = "one_month",
  one_week = "three_months",
  one_day = "one_day",
  custom = "custom"
}

export interface ErrorResponse {
  error: any
}
export interface FetchClusterRequest {
  id: string
}

export interface FetchClusterErrorResponse {
  id: string,
  error: any
}

export interface FetchClusterResponse {
  response: Cluster
}

export interface FetchAssetsRequest {
  requestBody: FilterBody,
  page: number,
  isForDownload: boolean
}

interface FilterBody {
  filters: Filter[],
  orderBy: string,
  query: string,
  sortBy: string
}

export interface FetchAssetsResponse {
  response: PaginatedRecords<Asset>
}


export interface CreateClusterRequest {
  requestBody: {
    filters: Filter[],
    filtersSet: boolean,
    name: string,
    nameSet: boolean
  }
}

export interface UpdateClusterRequest {
  id: string,
  requestBody: {
    filters: Filter[],
    filtersSet: boolean,
    name: string,
    nameSet: boolean
  }
}

export interface DeleteAssetsRequest {
  filters: Filter[]
}

export interface UpdateAssetsRequest {
  customFields: CustomFieldItem[],
  filters?: Filter[],
  permissions: {
    download: AssetAccess
    share: AssetAccess
  },
  tags: string[],
  expriyDate: string | null
}

export interface CustomFieldItem {
  id: string,
  name: string,
  value : CustomFieldValue[]
}

interface CustomFieldValue{
  id: string,
  value: string
}

export enum AssetAccess {
  none = "NONE",
  true = "TRUE",
  false = "FALSE"
}

